import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ContentCategory } from '@/types';
import { categoryApi } from '@/store/api/categoryApi';


interface ContentState {
  categories: ContentCategory[];
}

const initialState: ContentState = {
  categories: [],
};
export const categorySlice = createSlice({
  name: 'category',
  initialState,
  reducers: {
    setCategories(state, action: PayloadAction<ContentCategory[]>) {
      state.categories = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      categoryApi.endpoints.getContentCategories.matchFulfilled,
      (state, { payload }) => {
        state.categories = payload;
      }
    );
  },
});

export const { setCategories } = categorySlice.actions;
export default categorySlice.reducer;